import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { speedingsQueryKeys } from "./queryKeys"

export function useTraffics(parameters = {}, config = {}) {
    const url = "traffic/traffics/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = speedingsQueryKeys.traffics(queryParameters)

    return useAuthenticatedQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}

export function useTraffic(trafficId, parameters = {}, config = {}) {
    const url = `traffic/traffics/${trafficId}/`
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = speedingsQueryKeys.traffics(trafficId, parameters)

    return useAuthenticatedQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}